/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import '../vendors/owl.carousel.min';
import '../vendors/slick.min';

jQuery( document ).on( 'mouseover click', '.bln-room-data-filter', function() {
	const myclass = jQuery( this ).attr( 'data-id' );
	jQuery( '.bln-accomo-toggle' ).hide();
	jQuery( '.bln-post-' + myclass ).show();
	jQuery( '.bln-room-data-filter' ).removeClass( 'bln-active' );
	jQuery( this ).addClass( 'bln-active' );
} );

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( '.bln-header-section, body' ).addClass( 'bln-shrink' );
	} else {
		jQuery( '.bln-header-section, body' ).removeClass( 'bln-shrink' );
	}
} );

jQuery( document ).ready( function() {
	jQuery( '.top-search' ).click( function() {
		jQuery( '.search-form-new' ).toggleClass( 'open' );
		jQuery( '.bln-header-section' ).toggleClass( 'blue-color' );
	} );
	jQuery( '.search-close,.menu-btn' ).click( function() {
		jQuery( '.search-form-new' ).removeClass( 'open' );
		jQuery( '.bln-header-section' ).removeClass( 'blue-color' );
	} );
	jQuery( '.search-close' ).on( 'click', function() {
		jQuery( '.keyword' ).val( '' );
	} );
	//
	jQuery( '.bln-contact-form-inner select' ).change( function() {
		const selectedOption = jQuery( this ).find( 'option:selected' );
		const selectElement = jQuery( this );

		// Remove the active class from the current select element
		selectElement.removeClass( 'active-option' );

		// Add the active class to the current select element if an option other than the first is selected
		if ( selectedOption.index() !== 0 ) {
			selectElement.addClass( 'active-option' );
		}
	} );
	const jqueryheaderHeight = jQuery( 'header' ).outerHeight();
	jQuery( 'body' ).css( 'padding-top', jqueryheaderHeight + 'px' );

	jQuery( '.bln-menu-btn' ).click( function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.bln-nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.bln-header-nav ul li.active' ).removeClass( 'active' );
		// jQuery( '.bln-header-nav ul.sub-menu' ).slideUp();
		const $menuLabel = jQuery( '.bln-menu-label' );

		// Toggle the text of the menu label
		$menuLabel.text( function( i, text ) {
			return text === 'Menu' ? 'Close' : 'Menu';
		} );
	} );
	jQuery.noConflict();
	// Mobile menu Script
	jQuery( document ).ready( function() {
		if ( jQuery( window ).width() < 1004 ) {
			jQuery( document ).on(
				'click',
				'li.menu-item-has-children > a',
				function( e ) {
					e.preventDefault();
					const parentLi = jQuery( this ).parent();
					const parentUl = parentLi.parent();
					const subMenu = parentLi.find( 'ul:first' );

					parentUl.addClass( 'sub-menu-open' );
					parentLi.addClass( 'active' );
					subMenu.addClass( 'menu-open' ).show();

					if ( ! subMenu.find( '.menu-back-link' ).length ) {
						subMenu.prepend(
							'<li class="menu-back-link"><a href="#">Back</a></li>'
						);
					}
				}
			);

			jQuery( document ).on( 'click', '.menu-back-link', function( e ) {
				e.preventDefault();

				const backLink = jQuery( this );
				const subMenu = backLink.parent();
				const parentLi = subMenu.parent();
				const parentUl = parentLi.parent();

				subMenu.removeClass( 'menu-open' );
				parentLi.removeClass( 'active' );

				setTimeout( function() {
					parentUl.removeClass( 'sub-menu-open' );
				}, 200 );

				setTimeout( function() {
					backLink.remove();
				}, 500 );

				jQuery( '.toggle-icon' ).removeClass( 'open' );
				jQuery( 'body' ).removeClass( 'menu-open' );
				jQuery( '.sub-sub-menu' ).hide();
			} );
		}

		jQuery( '.sub-menu .menu-item-has-children > a' ).each( function() {
			jQuery( this ).append(
				'<i class="fa fa-chevron-down toggle-icon"></i>'
			);
		} );

		jQuery( '.sub-menu .menu-item-has-children > .sub-menu' ).hide();

		jQuery(
			'.menu-item-depth-1.menu-item-has-children > a.sub-menu-link'
		).on( 'click', function( e ) {
			e.preventDefault();
			jQuery( this ).find( '.toggle-icon' ).trigger( 'click' );
		} );

		jQuery( '.sub-menu .menu-item-has-children > a .toggle-icon' ).on(
			'click',
			function( e ) {
				e.preventDefault();

				const toggleIcon = jQuery( this );
				const submenu = toggleIcon.closest( 'a' ).siblings( '.sub-menu' );

				if ( ! submenu.is( ':animated' ) ) {
					submenu.slideToggle( 300 );
					toggleIcon.toggleClass( 'open' );
				}

				if ( jQuery( '.toggle-icon.open' ).length ) {
					jQuery( 'body' ).addClass( 'menu-open' );
				} else {
					jQuery( 'body' ).removeClass( 'menu-open' );
				}

				e.stopPropagation();
			}
		);
	} );

	/**
	 * Timeline animation
	 */

	gsap.registerPlugin( ScrollTrigger );

	document
		.querySelectorAll( '.timeline-line' )
		.forEach( ( timelineLine, index ) => {
			const timeline = timelineLine.closest( '.bln-single-timeline' );
			const timelineHeight = timeline.clientHeight - 100;
			gsap.from( timelineLine, {
				scrollTrigger: {
					trigger: timeline,
					scrub: true,
					start: 'top center+=250',
					end: `top+=${ timelineHeight } center+=250`,
				},
				scaleY: 0,
				transformOrigin: 'top center',
				ease: 'none',
			} );
		} );
	document
		.querySelectorAll( '.timeline-circle' )
		.forEach( ( timelineLine, index ) => {
			const timeline = timelineLine.closest( '.bln-single-timeline' );
			gsap.to( timelineLine, {
				scrollTrigger: {
					trigger: timeline,
					scrub: true,
					start: 'top center+=250',
					end: `top center+=250`,
				},
				scale: 1.3,
				transformOrigin: 'center',
			} );
		} );

	jQuery( '.bln-iat-content-slider' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		fade: false,
		asNavFor: '.bln-iat-image-slider',
		adaptiveHeight: true,
	} );

	jQuery( '.bln-iat-image-slider' ).slick( {
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: '.bln-iat-content-slider',
		dots: false,
		arrows: false,
		focusOnSelect: true,
		fade: false,
	} );

	jQuery( '.bln-as-images-slider' ).owlCarousel( {
		items: 3,
		loop: false,
		margin: 32,
		nav: true,
		dots: true,
		autoplay: false,
		slideBy: 3,
		scrollPerPage: true,
		navigation: true,
		responsive: {
			0: {
				items: 1,
				margin: 26,
				stagePadding: 50,
			},
			600: {
				items: 2,
				stagePadding: 50,
			},
			768: {
				items: 2,
			},
			1003: {
				items: 3,
			},
		},
	} );
	/**
	 * Cursor for adventure slider
	 */

	// set the starting position of the cursor outside of the screen
	// if ( jQuery( window ).width() > 747 ) {
	// 	console.log( 'screen width greater than 747' );
	// 	let clientX = -100;
	// 	let clientY = -100;
	// 	let lastX = -100;
	// 	let lastY = -100;
	// 	const cursor = document.querySelector( '.cursor' );
	// 	const section = document.querySelector(
	// 		'.bln-as-images-slider .owl-stage-outer'
	// 	);

	// 	// Show/hide the cursor when it is over the section
	// 	// if ( section ) {
	// 	// 	section.addEventListener( 'mouseenter', () => {
	// 	// 		cursor.classList.add( 'visible' );
	// 	// 	} );

	// 	// 	section.addEventListener( 'mouseleave', () => {
	// 	// 		cursor.classList.remove( 'visible' );
	// 	// 	} );
	// 	// }

	// 	// function for linear interpolation of values
	// 	const lerp = ( a, b, n ) => {
	// 		return ( 1 - n ) * a + n * b;
	// 	};

	// 	const initCursor = () => {
	// 		if ( ! cursor ) {
	// 			return;
	// 		}

	// 		// add listener to track the current mouse position
	// 		document.addEventListener( 'mousemove', ( e ) => {
	// 			clientX = e.clientX;
	// 			clientY = e.clientY;
	// 		} );

	// 		// transform the cursor to the current mouse position
	// 		// use requestAnimationFrame() for smooth performance
	// 		const render = () => {
	// 			// lesser delta, greater the delay that the custom cursor follows the real cursor
	// 			const delta = 0.1;
	// 			lastX = lerp( lastX, clientX, delta );
	// 			lastY = lerp( lastY, clientY, delta );

	// 			cursor.style.transform = `translate(${ lastX }px, ${ lastY }px)`;

	// 			requestAnimationFrame( render );
	// 		};

	// 		requestAnimationFrame( render );
	// 	};

	// 	initCursor();
	// }

	jQuery.noConflict();

	jQuery( '.bln-image-collage' ).owlCarousel( {
		center: true,
		items: 1,
		loop: true,
		margin: 0,
		nav: false,
		dots: true,
		autoplay: true,
		autoplayTimeout: 5000,
		autoplayHoverPause: true,
	} );
	jQuery( '.bln-banner-slider' ).owlCarousel( {
		center: false,
		items: 1,
		loop: true,
		margin: 0,
		smartSpeed: 800,
		dotsSpeed: 800,
		dragEndSpeed: 800,
		nav: true,
		dots: true,
	} );

	/**
	 * FAQ Block
	 */
	jQuery( '.faq > span' ).on( 'click', function() {
		if ( jQuery( this ).parent().hasClass( 'active' ) ) {
			jQuery( this ).parent().removeClass( 'active' );
			jQuery( this ).siblings( '.faq-content' ).slideUp();
		} else {
			jQuery( '.faq > span' ).parent().removeClass( 'active' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( '.faq-content' ).slideUp();
			jQuery( this ).siblings( '.faq-content' ).slideDown();
		}
	} );
} );

/**
 * Document Ready Function
 * Triggered when document get's ready
 */

jQuery( document ).ready( function() {
	// Magnific Popup Script
	setTimeout( () => {
		const currentURL = window.location.href;
		const hasArray = currentURL.split( '#' );
		const hasID = '#' + hasArray[ hasArray.length - 1 ];
		if ( hasID === '#book-a-room' ) {
			if ( jQuery( '.book-a-room-section' ).hasClass( 'popup-active' ) ) {
				jQuery( '.book-a-room-section' ).removeClass( 'popup-active' );
			} else {
				jQuery( '.book-a-room-section' ).addClass( 'popup-active' );
			}
		} else if ( hasID === '#book-a-table' ) {
			if ( jQuery( '.book-a-table-section' ).hasClass( 'popup-active' ) ) {
				jQuery( '.book-a-table-section' ).removeClass( 'popup-active' );
			} else {
				jQuery( '.book-a-table-section' ).addClass( 'popup-active' );
			}
		}
	}, 100 );
	jQuery( document ).on( 'click', 'a', function( e ) {
		if ( jQuery( this ).attr( 'href' ) === '#book-a-room' ) {
			if ( jQuery( '.book-a-room-section' ).hasClass( 'popup-active' ) ) {
				jQuery( '.book-a-room-section' ).removeClass( 'popup-active' );
			} else {
				jQuery( '.book-a-room-section' ).addClass( 'popup-active' );
			}
		} else if ( jQuery( this ).attr( 'href' ) === '#book-a-table' ) {
			if ( jQuery( '.book-a-table-section' ).hasClass( 'popup-active' ) ) {
				jQuery( '.book-a-table-section' ).removeClass( 'popup-active' );
			} else {
				jQuery( '.book-a-table-section' ).addClass( 'popup-active' );
			}
		}
	} );
	jQuery( document ).click( function( e ) {
		const container1 = jQuery( '.book-a-table-section' );
		const container1_btn = jQuery( 'a[href="#book-a-table"]' );
		const container2 = jQuery( '.book-a-room-section' );
		// const closePopup = jQuery( '.bln-popup-close' );
		const container2_btn = jQuery( 'a[href="#book-a-room"]' );
		// if the target of the click isn't the container nor a descendant of the container
		if (
			! container1.is( e.target ) &&
			container1.has( e.target ).length === 0 &&
			! container1_btn.is( e.target ) &&
			container1_btn.has( e.target ).length === 0
		) {
			jQuery( '.book-a-table-section' ).removeClass( 'popup-active' );
			history.replaceState(
				'',
				document.title,
				window.location.origin +
				window.location.pathname +
				window.location.search
			);
		}
		// if the target of the click isn't the container nor a descendant of the container
		if (
			! container2.is( e.target ) &&
			container2.has( e.target ).length === 0 &&
			! container2_btn.is( e.target ) &&
			container2_btn.has( e.target ).length === 0
		) {
			jQuery( '.book-a-room-section' ).removeClass( 'popup-active' );
			history.replaceState(
				'',
				document.title,
				window.location.origin +
				window.location.pathname +
				window.location.search
			);
		}
	} );
	jQuery( '.bln-popup-close' ).click( function( e ) {
		console.log( 'activated ' );
		jQuery( this ).parent().removeClass( 'popup-active' );
	} );

	// jQuery('.book-now-buttons').hide('showbook-buttons');
	jQuery( '.bln-open-book-btns' ).on( 'click', function() {
		// console.log("open-button");
		// jQuery(this).addClass("open");
		jQuery( '.bln-book-now-buttons' ).toggle();
		jQuery( '.bln-book-now-buttons' ).toggleClass( 'bln-showbook-buttons' );
	} );

	jQuery( window ).scroll( function() {
		const footerTop = jQuery( '.bln-footer-section' ).offset().top;
		const scrollTop = jQuery( window ).scrollTop();
		const windowHeight = jQuery( window ).height();

		if ( scrollTop + windowHeight >= footerTop ) {
			jQuery( '.bln-floating-cta' ).addClass( 'bln-hide' );
		} else {
			jQuery( '.bln-floating-cta' ).removeClass( 'bln-hide' );
		}
	} );

	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.sub-menu' ).removeClass( 'focused' );
		} );

	if ( navigator.userAgent.indexOf( 'Mac OS X' ) != -1 ) {
		jQuery( 'body' ).addClass( 'style-for-apple' );
	} else {
		jQuery( 'body' ).addClass( 'style-for-window' );
	}

	// 	/**
	// 	 * Add span tag to multi-level accordion menu for mobile menus
	// 	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this ).find( 'a:first' );
			// .after( '<span class="submenu-icon"></span>' );
		}
	} );
	// 	/**
	// 	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	// 	 */
	jQuery( '.bln-header-nav .submenu-icon' ).click( function() {
		const link = jQuery( this );
		const closestUl = link.closest( 'ul' );
		const parallelActiveLinks = closestUl.find( '.active' );
		const closestLi = link.closest( 'li' );
		const linkStatus = closestLi.hasClass( 'active' );
		let count = 0;

		closestUl.find( 'ul' ).slideUp( function() {
			if ( ++count === closestUl.find( 'ul' ).length ) {
				parallelActiveLinks.removeClass( 'active' );
			}
		} );

		if ( ! linkStatus ) {
			closestLi.children( 'ul' ).slideDown();
			closestLi.addClass( 'active' );
		}
	} );

	if ( jQuery( '.bln-header-wrapper' ).length > 0 ) {
		function updateHeaderHeight() {
			jQuery( '.bln-header-wrapper' ).each( function() {
				jQuery( this ).css( '--em_header-wrapper-default', jQuery( this ).outerHeight() + 'px' );
			} );
		}
		updateHeaderHeight();
		jQuery( window ).resize( updateHeaderHeight );
	}
	if ( jQuery( '.video-wrapper' ).length > 0 ) {
		const iframe = document.getElementById( 'my-vimeo-player' );
		if ( iframe ) {
			const player = new Vimeo.Player( iframe );
			const muteIconButton = jQuery( '.audio-icon' );
			const playIconButton = jQuery( '.play-icon-btn' );

			muteIconButton.on( 'click', function() {
				player.getVolume().then( function( volume ) {
					if ( volume === 0 ) {
						player.setVolume( 1 ).then( function() {
							muteIconButton.addClass( 'unmute-video' );
						} );
					} else {
						player.setVolume( 0 ).then( function() {
							muteIconButton.removeClass( 'unmute-video' );
						} );
					}
				} );
			} );

			playIconButton.on( 'click', function() {
				player.getPaused().then( function( paused ) {
					if ( paused ) {
						player.play().then( function() {
							playIconButton.removeClass( 'pause-video' );
						} );
					} else {
						player.pause().then( function() {
							playIconButton.addClass( 'pause-video' );
						} );
					}
				} );
			} );
		}
	}
} );
